import { Route } from '@angular/router';
import { TicketBoardComponent } from '../../dashboard/ticket-board/ticket-board.component';

export function addDynamicPath(config: Array<Route>, modulePath, data): Promise<Array<Route>> {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      let configIsChanged = false;
      config.forEach(root => {
        if (root.children) {
          const foundChild: any = root.children.find(child => (child as any)._loadedConfig && child.path === modulePath);
          if (foundChild && foundChild._loadedConfig.routes.length > 0) {
            foundChild._loadedConfig.routes.forEach(childRoute => {
              if (childRoute.data && childRoute.data.addDynamicChild) {
                if (!childRoute.children) {
                  childRoute.children = [];
                }
                data.map(x => {
                  const foundDynamicChild = childRoute.children.find(child => child.path === 'dynamic');
                  if (!foundDynamicChild) {
                    if(childRoute.children.findIndex(x=> x.path === x.routeName) === -1){
                      childRoute.children.push(
                        {
                          path: x.routeName,
                          component: TicketBoardComponent
                          // loadChildren: () => import('../../dashboard/dashboard.module').then(m => m.DashboardModule)
                        }
                      );
                      configIsChanged = true;
                    }
                  }
                })
              }
            });
          }
        }
      });
      if (configIsChanged) {
        resolve(config);
      }
      resolve(null);
    }, 0);
  });
}